// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cjnT0wnlMZkHEE {
  width: 100%;
  margin: var(--ds-space-050, 4px);
  list-style-type: none;
}
.cjnT0wnlMZkHEE.E2u4SSQ6k9aBhb {
  opacity: 0.4;
}
.cjnT0wnlMZkHEE.Thmw3OW8ovkrku {
  display: none;
}
.pqMLe0_4btYok7 {
  margin: var(--ds-space-050, 4px);
}
.ExOxu4gCgbZkcT {
  height: 100%;
  margin: var(--ds-space-0, 0);
}
.wAE7lhoc_bBZBi {
  width: 100%;
  margin: var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItem": `cjnT0wnlMZkHEE`,
	"isDragging": `E2u4SSQ6k9aBhb`,
	"isMoving": `Thmw3OW8ovkrku`,
	"listItemGrid": `pqMLe0_4btYok7`,
	"switcherTileStyleOverwrite": `ExOxu4gCgbZkcT`,
	"dropIndicator": `wAE7lhoc_bBZBi`
};
export default ___CSS_LOADER_EXPORT___;
